<script>
    import checkInstantWins from "$lib/firestore/checkInstantWins";
	import posthog from "posthog-js";
    import { onMount } from "svelte";
    import { fade } from "svelte/transition";

    // let assignedNumbers = {
    //     "7cQZV00qEVCAEbBvzHwP": [587, 600, 10019], // Numbers only
    //     "Mt5Wega5daPsF4M8xoGz": [460],
    //     "QXs6OsQFZZDBYQPOsb4r": [5, 10147],
    // };

    export let assignedNumbers;
    console.log({assignedNumbers})

    let matchedPrizes = [];
    let isChecking = false;
    let hasChecked = false;
    let hasMatches = false;

    async function fetchMatchedPrizes() {
        try {
            isChecking = true;
            matchedPrizes = await checkInstantWins(assignedNumbers);
            hasMatches = matchedPrizes.length > 0;
            hasChecked = true;

            posthog.capture("instant_win_checked", {
                hasMatches,
                matchedPrizes,
            });

        } catch (error) {
            console.error("Error fetching matched prizes:", error);
            alert("An error occurred while checking for winning tickets.");
        } finally {
            isChecking = false;
        }
    }
</script>

<style>
    :global(body) {
        /* font-family: 'Arial', sans-serif; */
        /* color: #222222; */
    }
 

    .results {
        /* margin-top: 20px; */
        padding: 20px;
        border-radius: 10px;
        background-color: #f9f9f9;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        text-align: center;
    }

    .winning-message {
        font-size: 24px;
        font-weight: bold;
        color: #fe1100;
        margin-bottom: 15px;
    }

    .winning-tickets {
        list-style-type: none;
        padding: 0;
        font-size: 18px;
    }

    .winning-tickets li {
        margin: 10px 0;
    }

    .no-match {
        color: #666;
        /* font-size: 18px; */
        margin-top: 20px;
    }

    .loading {
        font-size: 16px;
        color: #666;
        margin-top: 10px;
    }

    .instant-win-check {
        margin: 20px auto;
        border-top: 1px solid #ccc;
        /* border-bottom: 1px solid #ccc; */
    }
</style>

<div class="instant-win-check">
    <h4>Entered into an instant win competition?</h4>
    <p>Check your ticket numbers here</p>
    <button class="btn" on:click={fetchMatchedPrizes} disabled={isChecking}>
        {isChecking ? "Checking for Wins..." : "Check for Winning Tickets"}
    </button>

    {#if isChecking}
        <p class="loading">Hang tight, we're checking your tickets...</p>
    {/if}

    {#if hasChecked}
        <div class="results" transition:fade>
            {#if hasMatches}
                <div>
                    <p class="winning-message">🎉 Congratulations! 🎉</p>
                    <p>You've got winning tickets for the following prizes:</p>
                    <ul class="winning-tickets">
                        {#each matchedPrizes as match}
                            <li>
                                <strong>Prize:</strong> {match.prize}<br />
                                <strong>Ticket number:</strong> {match.ticketNumber}<br />
                                <!-- <strong>Prize ID:</strong> {match.prizeId} -->
                                <a href="mailto:help@hotdraw.co.uk?subject=Claiming%20Prize:%20{encodeURIComponent(match.prize)}">
                                    Email us to claim your prize
                                </a>
                            </li>
                        {/each}
                    </ul>

                </div>
            {:else}
                <p class="no-match">
                    Sorry, no winning tickets this time. But don't give up, you might win next time!
                </p>
            {/if}
        </div>
    {/if}
</div>
